import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["heading"];
import React from 'react';
import styled from "../../styled-components.mjs";
export var StyledHeadingTag = styled.h2.withConfig({
  displayName: "HeadingElement__StyledHeadingTag",
  componentId: "sc-1fqxeih-0"
})(["margin:0;"]);
export var HeadingElement = /*#__PURE__*/React.forwardRef(function Heading(_ref, ref) {
  var heading = _ref.heading,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledHeadingTag, Object.assign({
    as: heading
  }, props, {
    ref: ref
  }));
});